import { createSlice } from "@reduxjs/toolkit";
import { getAppointmentById } from "../../reducer/getAppointmentById/getAppointmentByIdReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const getAppointmentByIdSlice = createSlice({
  name: "getAppointmentById",
  initialState,
  reducers: {
    clearAppointmentById: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppointmentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAppointmentById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getAppointmentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearAppointmentById } = getAppointmentByIdSlice.actions;
export default getAppointmentByIdSlice.reducer;
